import { ComponentMultiStyleConfig } from '@chakra-ui/react';

const ModalTheme: ComponentMultiStyleConfig = {
  parts: ['dialog', 'header', 'overlay', 'dialogContainer', 'closeButton', 'body', 'footer'],
  baseStyle: () => ({
    header: {
      color: 'grey.dark',
      fontsize: 'lg',
      borderBottom: '1px solid',
      borderColor: 'grey.lightest',
      mb: 4
    },
    footer: {
      borderTop: '1px solid',
      borderColor: 'grey.lightest',
      mt: 4
    }
  })
};

export default ModalTheme;
